import { z } from 'zod'

/**
 * Validated environment variables — import `env` instead of `import.meta.env` directly.
 * Fails fast at startup with a clear error if required variables are malformed.
 */
const schema = z.object({
    VITE_KEYCLOAK_URL:       z.string().url().optional(),
    VITE_KEYCLOAK_REALM:     z.string().min(1).default('cloud-app'),
    VITE_KEYCLOAK_CLIENT_ID: z.string().min(1).default('cloud-app-client'),
})

export const env = schema.parse(import.meta.env)
